import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Eye, EyeOff, Lock } from "lucide-react";
import { api, formatApiErrorDetail } from "../lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/login", { email, password });
      navigate("/admin/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-basalt px-6 font-sans" data-testid="admin-login-page">
      <div className="w-full max-w-sm">
        <div className="mb-10 text-center">
          <Link to="/" data-testid="admin-login-logo" className="inline-block transition-opacity hover:opacity-80">
            <img src="/logo.svg" alt="AZORUniqueHome" className="mx-auto h-8 w-auto" />
          </Link>
          <p className="mt-3 flex items-center justify-center gap-2 font-mono text-[11px] uppercase tracking-[0.3em] text-mist">
            <Lock size={11} /> Área Reservada
          </p>
        </div>

        <form
          onSubmit={handleSubmit}
          className="rounded-xl border border-white/10 bg-surface p-8"
          data-testid="admin-login-form"
        >
          <label className="block">
            <span className="mb-1.5 block font-mono text-[11px] uppercase tracking-widest text-mist">Email</span>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email-input"
              className="w-full rounded-md border border-white/10 bg-basalt px-3.5 py-2.5 text-sm text-sand outline-none transition-colors focus:border-terracotta"
            />
          </label>

          <label className="mt-5 block">
            <span className="mb-1.5 block font-mono text-[11px] uppercase tracking-widest text-mist">
              Palavra-passe
            </span>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-password-input"
                className="w-full rounded-md border border-white/10 bg-basalt px-3.5 py-2.5 pr-11 text-sm text-sand outline-none transition-colors focus:border-terracotta"
              />
              <button
                type="button"
                onClick={() => setShowPassword((v) => !v)}
                data-testid="admin-toggle-password"
                className="absolute right-3 top-1/2 -translate-y-1/2 text-mist transition-colors hover:text-sand"
                aria-label={showPassword ? "Ocultar palavra-passe" : "Mostrar palavra-passe"}
              >
                {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
          </label>

          {error && (
            <p className="mt-4 rounded-md border border-terracotta/40 bg-terracotta/10 px-3 py-2 text-xs text-terracotta" data-testid="admin-login-error">
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="mt-7 w-full rounded-full bg-terracotta py-3 text-sm font-medium text-basalt transition-colors hover:bg-sand disabled:opacity-50"
          >
            {loading ? "A entrar…" : "Entrar"}
          </button>
        </form>

        <Link
          to="/"
          data-testid="admin-back-to-site"
          className="mt-6 block text-center font-mono text-[11px] tracking-widest text-sand/40 transition-colors hover:text-terracotta"
        >
          ← Voltar ao site
        </Link>
      </div>
    </div>
  );
}
